var map = {
	"./banprime/logo-shadow.png": "9c2c",
	"./ezzebank/logo-shadow.png": "03cb",
	"./groovebank/logo-shadow.png": "917e",
	"./hubchain/logo-shadow.png": "334a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f0d5";